export default __webpack_public_path__ + "static/media/Neophyte's Armbands of the Dark Pact.d2cf5d03.jpg";